module.exports = __webpack_public_path__ + "img/badge-resident-darkbg.53480963.svg";